<template>
  <div class="instructors-reel" v-if="instructors && instructors.length">
    <Swiper
      class="instructors-reel-carousel__swiper"
      :parentClass="`instructors-reel-carousel__parent-class`"
      :swiperOptions="swiperOptions"
    >
      <InstructorTile
        v-for="(instructor, index) in instructors"
        :key="instructor.id"
        :instructor="instructor"
        :height="455"
        :index="index"
        :learningAreaName="learningAreaName"
        :bootcamp="bootcamp"
        class="swiper-slide"
      />
    </Swiper>
  </div>
</template>

<script>
import Swiper from '@/components/layout/Swiper.vue'
import InstructorTile from './InstructorTile.vue'

export default {
  name: 'InstructorsReel',
  components: {
    Swiper,
    InstructorTile,
  },
  props: {
    instructors: {
      type: Array,
      required: true,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
    bootcamp: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      currentPosition: 1,
    }
  },
  computed: {
    swiperOptions() {
      let multipleInstructorsOptions = {}
      const oneInstructorOptions = {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
        },
      }
      if (this.instructors.length > 1) {
        multipleInstructorsOptions = {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
          loop: true,
          autoplay: {
            delay: 5000,
          },
          mousewheel: {
            forceToAxis: true,
          },
          chevrons: true,
        }
      }
      const options = Object.assign(
        oneInstructorOptions,
        multipleInstructorsOptions
      )
      return options
    },
  },
}
</script>

<style lang="scss" scoped>
.instructors-reel {
  width: 100%;
}
.swiper-slide {
  width: 100%;
}
::v-deep .swiper-container {
  width: 100%;
  @include mobile {
    width: 90%;
  }
  @include tablet {
    width: 80%;
  }
  .swiper-button-prev,
  .swiper-button-next {
    color: #fff;
    font-weight: 700;
    transition: all 0.5s ease;
    height: 100%;
    top: 0;
    bottom: 0;
    margin: 0;
    background: none;
    width: auto;
    &:hover {
      opacity: 1;
    }
    &:after {
      display: none;
    }
  }

  .swiper-button-prev {
    display: block !important;
    left: calc(50% - 85px);
    transform: translateX(-50%);
    @include mobile {
      width: 70px;
      background: none;
      left: calc(50% - 135px);
    }
  }
  .swiper-button-next {
    display: block !important;
    right: calc(50% - 85px);
    transform: translateX(50%);
    @include mobile {
      background: none;
      width: 70px;
      right: calc(50% - 135px);
    }
  }
  .swiper-button-disabled {
    display: block;
  }
  .swiper-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 55%;
    transition: 0.2s all ease;
    &:hover {
      transform: scale(1.2);
    }
    @include mobile {
      background: none;
      height: 72%;
    }
  }
  .swiper-icon-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 100%;
    background-color: unset;
  }
  .swiper-icon {
    fill: transparent;
    min-width: 24px;
    height: 24px;
  }
  .swiper-pagination-bullets {
    bottom: -5px;
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: var(--white);
    opacity: 0.2;
    &-active {
      opacity: 1;
    }
  }
}
</style>
